
import { get as apiGet } from 'Api';
import store from 'Redux/store';
import { sendProductAggregate } from 'Redux/ducks/events';

const language = window.locale || 'en';

export function checkVideoData(src) {
  const url = `/products/video-check/${src}`;
  return apiGet(store.dispatch, url, true)
    .then(({ response, data }) => {
      if (response.status !== 200) {
        return 'failed to fetch';
      }
      return data.status;
    });
}

export function fetchProduct(slug) {
  const url = `/products-group/${slug}/${language}`;
  return apiGet(store.dispatch, url, true)
    .then(({ response, data }) => {
      if (response.status === 401) {
        return fetchProduct(slug);
      }

      if (response.status > 400) {
        return { product: null, notFound: true };
      }

      if (data && data.redirect) {
        return { redirect: `${data.redirect}${data.name ? `#bundle-ended-${encodeURIComponent(data.name)}` : ''}` };
      }

      sendProductAggregate(data);
      return { product: data };
    });
}

export function fetchProductPreview(id, key) {
  let url = `/admin/products/preview/${id}/${language}`;
  if (key) url = `/products/key-preview/${id}/${language}?key=${key}`;

  return apiGet(store.dispatch, url)
    .then(async ({ response, data }) => {
      if (response.status === 401) {
        alert('Log in as an admin to preview products'); // eslint-disable-line no-alert
      }

      if (response.status > 400) {
        return { product: null, notFound: true };
      }

      return { product: { ...data, isPreview: !!key } };
    });
}

export async function getSampleDownloadUrl(fileID) {
  const { response, data } = await apiGet(store.dispatch, `/products/download-sample/${fileID}`);

  if (response.ok) return data;
  throw Error(response.statusText);
}
